import React from 'react';
import ProgressBar from '@bit/nexxtway.react-rainbow.progress-bar';

export default class Bar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      count: 0
    };
  }

  componentDidMount() {
    let total = 1;
    this.props.activities.forEach( a => {
      if (a.field_materials && a.field_materials.length) {
        total += a.field_materials.length
      }
    });
    this.props.elem.current.addEventListener("update", () => {
      this.setState({
        value: (this.state.count + 1) / total * 100,
        count: this.state.count + 1
      })
    })
  }

  componentWillUnmount () {
    this.props.elem.current.removeEventListener("update", () => null)
  }

  render() {
    const { value } = this.state;
    return (
      <ProgressBar value={value} className={'progress-bar'} />
    );
  }
}
